import QuantitySelectorBaseGifts from './GiftsCarrouselQuantitySelector';
import { Text } from 'ui/components/primitives';
import { actions } from 'core/use-cases/checkout';
import { useCommand } from 'core/use-cases/utilities';
import { GiftStyles } from '../Gifts.styles';
import { useAppCommand } from 'core/use-cases/app/commands';
import type { SelectedPromotionItemQuantity } from 'core/domains/checkout';

type TGiftsCarrouselButton = {
  available: boolean;
  isCompleted: boolean;
  isDisabled: boolean;
  max: number;
  quantity: number;
  item: SelectedPromotionItemQuantity;
};

export const GiftsCarrouselButton = ({
  available,
  isCompleted,
  isDisabled,
  max,
  quantity,
  item,
}: TGiftsCarrouselButton) => {
  const { trackClick } = useAppCommand();
  const { dispatchCommand } = useCommand();

  const addFirstItem = () => {
    dispatchCommand(
      actions.giftItemUpdate({
        index: item.index,
        method: 'add',
        giftNumber: item.gift.giftNumber,
        giftItemNumber: item.gift.giftItemNumber,
        giftQuantity: item.gift.giftQuantity,
        promotionCode: item.gift.promotion.code,
        nextOrderAllowed: item.gift.nextOrderAllowed,
        rewards: [
          {
            name: item.gift.items.find((selected) => item.sku === selected.sku)?.name || '',
            sku: item.sku,
            quantity: 1,
            images: item.gift.items.find((selected) => item.sku === selected.sku)?.images || [],
          },
        ],
      }),
    );
  };

  if (quantity > 0) {
    return (
      <GiftStyles.QuantityWrapper>
        <QuantitySelectorBaseGifts
          max={isCompleted ? quantity : max}
          size="medium"
          value={quantity}
          item={item}
        />
      </GiftStyles.QuantityWrapper>
    );
  }

  if (available) {
    return (
      <GiftStyles.ActionButton
        data-testid="choose-button"
        disabled={isDisabled || isCompleted}
        stretch
        onClick={(e) => {
          addFirstItem();

          trackClick(e, 'event', {
            eventAction: 'clique:botao',
            eventCategory: 'carrinho:brindes',
            eventLabel: `adicionar:${item.sku}`,
          });
        }}
      >
        <Text textAlign="center" variant="body-medium-short">
          Escolher
        </Text>
      </GiftStyles.ActionButton>
    );
  }

  return (
    <GiftStyles.ActionButton disabled stretch>
      <Text textAlign="center" variant="body-medium-short">
        Sem estoque
      </Text>
    </GiftStyles.ActionButton>
  );
};
